import { render, staticRenderFns } from "./floating-ip.vue?vue&type=template&id=1dc532bc&"
import script from "./floating-ip.vue?vue&type=script&lang=js&"
export * from "./floating-ip.vue?vue&type=script&lang=js&"
import style0 from "./floating-ip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports